import React, {useEffect, useState} from 'react';
import {requestGetEmployer, requestSaveEmployer} from "@app/services/EmployerService";
import {
    arrayToString,
    capitalizeArray,
    optionsToArray,
    optionsToString,
    stringToArray,
    stringToOption
} from "@app/utils/CommonUtils";
import EmployerBasicContent from "@pages/employer/edit/EmployerBasicContent";
import EmployerCategoryContent from "@pages/employer/edit/EmployerCategoryContent";
import {callApiSaveJob} from "@pages/job/common/Services";
import {ResponseCode} from "@app/constants/Common";
import {toast} from "react-toastify";
import {alertMessage, Messages, showMessage} from "@app/constants/Messages";
import EmployeesContent from "@pages/employer/edit/EmployeesContent";
import {validateEmployerInput} from "@pages/employer/common/ValidationUtil";
import CandidateGeneral from "@pages/candidate/detail/CandidateGeneral";
import EmployerGeneral from "@pages/employer/edit/EmployerGeneral";

const EditEmployer = (props) => {
    const [employer, setEmployer] = useState({});
    const [currentTab, setCurrentTab] = useState('employer-basic-tab');


    const employerName = new URLSearchParams(props.location.search).get("employer_name")
    const {employerId} = props.match.params
    const fetchEmployer = async (id) => {
        const res = await requestGetEmployer({employer_id: id});
        const emp = res.content
        if (emp) {
            // emp.local_nationality = stringToOption(emp.local_nationality)
            // emp.bd_status = stringToOption(emp.bd_status)
            // emp.local_province = stringToOption(emp.local_province)
            // emp.local_area = stringToOption(emp.local_area)
            // emp.industry = stringToArray(emp.industry)
            setEmployer(emp)
        }
    };

    useEffect(() => {
        if (employerId) {
            fetchEmployer(employerId)
        } else {
            employer.name = employerName;
            employer.brief_name = employerName;
            setEmployer({...employer})
        }
    },[]);

    const onTabClicked = (tabId) => {
        setCurrentTab(tabId);
    };

    const onChangeEmployerInfo = (changeEmp) => {
        const emp = {...employer, ...changeEmp}
        setEmployer(emp)
    };


    const onSaveEmployer = () => {
        if (!validateEmployerInput(employer)) {
            return;
        }

        requestSaveEmployer(employer).then((res) => {
            console.log(`Response-save user:${JSON.stringify(res)}`);
            if (res.sts_code === ResponseCode.SUCCESS) {
                const newEmployer = res.content
                employer.id = newEmployer.id
                setEmployer({...employer})
                toast.success(Messages.saveInfoSuccess)
            } else {
                alertMessage(res.sts_code, false, true)
                toast.error(Messages.saveInfoSFailed)
            }
        }).catch((error) => {
            console.log(`Error:${JSON.stringify(error)}`);
        }).finally(() => {
        });
    };

    const headerTitle = () => {
        if (!employer.id) {
            return <h3 className='card-title font-weight-bold'>Thông tin Employer</h3>
        }
        return <h3 className='card-title'>
            {employer.id && <span className={"mx-2"}>{employer.id}</span>}

            {employer.brief_name &&
            <> | <span className={'mx-2 text-primary text-bold h4'}>{employer.brief_name.toUpperCase()}</span></>
            }

            {employer.bd_status && <> | <span className={'mx-2'}>{employer.bd_status}</span></>}

            {employer.local_province &&
            <> | <span className={'mx-2'}>{capitalizeArray(stringToArray(employer.local_province)).join(" - ")}</span> </>
            }
            {employer.industry &&
            <> | <span className={'mx-2'}>{stringToArray(employer.industry).join(" - ")}</span>
            </>
            }
        </h3>
    }

    return (
        <>
            <div className='card card-default'>
                <div className='card-header'>
                    {headerTitle()}
                    <div className='card-tools'>
                        {employer.id &&
                        <a href={`/job/add?employerId=${employer.id}`} target={"_blank"}
                           rel="noopener noreferrer" className={'btn btn-info'}>
                            Tạo Job
                        </a>
                        }
                        <button type='button' className='btn btn-primary ml-2'
                                onClick={() => {
                                    onSaveEmployer()
                                }}>Save All
                        </button>
                    </div>
                </div>
                <div className='card-body p-0'>
                    <ul className='nav nav-tabs' role='tablist'>
                        <li className='nav-item'>
                            <a className='nav-link active' data-toggle='tab' href='#employer-basic-tab'
                               onClick={() => onTabClicked('employer-basic-tab')}>Basic info</a>
                        </li>
                        <li className='nav-item'>
                            <a className='nav-link' data-toggle='tab' href='#employer-category-tab'
                               onClick={() => onTabClicked('employer-category-tab')}>Phân loại</a>
                        </li>
                        <li className='nav-item'>
                            <a className='nav-link' data-toggle='tab' href='#employer-employees-tab'
                               onClick={() => onTabClicked('employer-employees-tab')}>Employees</a>
                        </li>
                        <li className='nav-item'>
                            <a className='nav-link' data-toggle='tab' href='#employer-general-tab'
                               onClick={() => onTabClicked('employer-general-tab')}>General</a>
                        </li>
                    </ul>
                    <div className='tab-content'>
                        {currentTab === "employer-basic-tab" &&
                            <div id='employer-basic-tab' className='tab-pane active'
                                 style={{height: '83vh', overflow: 'auto'}}>
                                <EmployerBasicContent employerInput={employer} onChange={(changeEmployer) => onChangeEmployerInfo(changeEmployer)}/>
                            </div>
                        }

                        {currentTab === "employer-category-tab" &&
                        <div id='employer-category-tab' className='tab-pane' style={{height: '83vh', overflow: 'auto'}}>
                            <EmployerCategoryContent employerInput={employer}
                                                     onChange={(changeEmployer) => onChangeEmployerInfo(changeEmployer)}/>
                        </div>
                        }

                        {currentTab === "employer-employees-tab" &&
                        <div id='employer-employees-tab' className='tab-pane'
                             style={{height: '83vh', overflow: 'auto'}}>
                            <EmployeesContent employerInput={employer}
                                              employerId={employerId}
                                              // onChange={(changeEmployer) => onChangeEmployerInfo(changeEmployer)}
                            />
                        </div>
                        }
                        {currentTab === "employer-general-tab" &&
                            <div id='employer-general-tab' className='tab-pane' style={{height: '83vh', overflow: 'auto'}}>
                                <EmployerGeneral employer={employer}/>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

export default EditEmployer;
